import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'FormWizard2',
  setup(__props) {

const CustomHorizontal = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard2/CustomHorizontal.vue"))
const BusinessHorizontal = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard2/BusinessHorizontal.vue"))
const CustomVertical = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard2/CustomVertical.vue"))
const BusinessVertical = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard2/BusinessVertical.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Controls",
      mains: "Form Wizard 2",
      title: "Form Wizard 2"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(CustomHorizontal)),
        _createVNode(_unref(BusinessVertical)),
        _createVNode(_unref(CustomVertical)),
        _createVNode(_unref(BusinessHorizontal))
      ])
    ])
  ], 64))
}
}

})